export function normalizeForecastBucketMap(forecastBucketConfig) {
    const labels = forecastBucketConfig?.accepted_forecast_field_label;

    if (!labels || typeof labels !== 'object' || Array.isArray(labels)) {
        return {};
    }

    return Object.fromEntries(
        Object.entries(labels).map(([key, value]) => [
            key,
            typeof value !== 'string' || value.trim() === '' ? key : value,
        ])
    );
}
